import React, { useRef } from "react";
import Title from "../../../../../components/Universal/Title.component";
import TuitionModalStudentCard from "../../../../../components/PagesComponents/Operational/Residential/Tuition/TuitionModalStudentCard.component";
import TuitionCard from "../../../../../components/PagesComponents/Operational/Residential/Tuition/TuitionCard.component";
import SecondModal from "../../../../../components/Universal/SecondModal.component";

// icons and images
import CrossBtnIcon from "../../../../../assets/Icons/Universal/Cross.svg";

import ProfileImg from "../../../../../assets/Images/TestImg/profileImage.png";

import { Form, Formik } from "formik";
import EveningShiftModalForm from "../../../../../components/PagesComponents/Operational/Residential/Tuition/EveningShiftModalForm.component";
import MorningShiftModalForm from "../../../../../components/PagesComponents/Operational/Residential/Tuition/MorningShiftModalForm.component";
import { Helmet } from "react-helmet";

const TuitionBody = ({
  filter,
  setFilter,
  classesFilter,
  setClassesFilter,
  lineChartData,
  studentDetailsModal,
  setStudentDetailsModal,
  editScheduleModal,
  setEditScheduleModal,
  editModalShiftChange,
  setEditModalShiftChange,
  // setLineChartData,
}) => {
  const scrollableContainer = useRef(null);
  return (
    <section className="pr-1 h-fit">
      <Helmet>
        <title>Tuition Management</title>
      </Helmet>
      <SecondModal
        isOpen={studentDetailsModal}
        onClose={setStudentDetailsModal}
      >
        <div
          className="flex-col align-center justify-center g-1"
          style={{ width: "30vw" }}
        >
          <div className="w-full flex-row align-center justify-between">
            <Title>All students of Class 5/A</Title>
            <button
              className="transparentCardBtn"
              onClick={() => setStudentDetailsModal(false)}
              style={{ border: "none" }}
            >
              <img src={CrossBtnIcon} alt="crossBtn" />
            </button>
          </div>
          <div className="w-full flex-row align-center justify-start g-3">
            <span className="color-greenColor t-11 poppins">45 Person</span>
            <ul>
              <li className="color-greenColor t-11 poppins">
                Appeared (A), Disappeared (D)
              </li>
            </ul>
          </div>
          <hr color="#e5e5e5" style={{ width: "100%" }} />
          <div
            className="w-full flex align-start justify-start scroll-y pr-1"
            style={{ height: "60vh" }}
          >
            <table id="tuitionModalTable">
              <thead>
                <tr>
                  <th>Residents</th>
                  <th>Today (M/E)</th>
                  <th>Appearance</th>
                </tr>
              </thead>

              <tbody>
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
                <TuitionModalStudentCard
                  image={ProfileImg}
                  name={"Toufik Alam"}
                  id={"SM0523019"}
                  today={"A/A"}
                  appearence={"30%"}
                />
              </tbody>
            </table>
          </div>
        </div>
      </SecondModal>

      <SecondModal isOpen={editScheduleModal} onClose={setEditScheduleModal}>
        <div
          className="flex-col align-start justify-start g-2"
          style={{ width: "35vw" }}
        >
          {/* header of edit modal */}
          <div className="flex-col align-start justify-start g-2">
            <div className="flex-row align-center justify-between">
              <label htmlFor="shift" className="t-14 poppins">
                {editModalShiftChange ? "Evening Shift" : "Morning Shift"}
              </label>
              <div className="toggleBtn">
                <label htmlFor="staffs" className="t-14 poppins">
                  Evening shift
                </label>
                <input
                  type="checkbox"
                  checked={editModalShiftChange}
                  onChange={(e) => setEditModalShiftChange(e.target.checked)}
                />
              </div>

              <button
                className="transparentBtn"
                type="button"
                onClick={() => setEditScheduleModal(false)}
              >
                <img src={CrossBtnIcon} alt="" />
              </button>
            </div>
            {/* save changes button conatiner */}
            <div className="flex-row align-center justify-end">
              <button type="button" className="actionBtn pl-2 pr-2">
                Save changes
              </button>
            </div>
            <hr />
          </div>
          {}
          <Formik
            initialValues={{
              eveningShift: {
                teachers: [""],
                subjects: [{ subject: "", topic: "" }],
                bestPerformers: [{ subject: "", name: "" }],
              },
              morningShift: {
                teachers: [""],
                subjects: [{ subject: "", topic: "" }],
                bestPerformers: [{ subject: "", name: "" }],
              },
            }}
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {({ setFieldValue, values }) => {
              const handleAddEveningTeacher = () => {
                const updatedVal = [...values.eveningShift.teachers, ""];
                setFieldValue("eveningShift.teachers", updatedVal);
              };

              const handleChangeEveningTeacher = (val, index) => {
                const updated = [...values.eveningShift.teachers];
                updated[index] = val;
                setFieldValue("eveningShift.teachers", updated);
              };

              const handleAddEveningSubject = () => {
                setFieldValue("eveningShift.subjects", [
                  ...values.eveningShift.subjects,
                  { subject: "", topic: "" },
                ]);
                setFieldValue("eveningShift.bestPerformers", [
                  ...values.eveningShift.bestPerformers,
                  { subject: "", name: "" },
                ]);
              };

              const handleChangeEveningSubject = (val, index, field) => {
                const updated = [...values.eveningShift.subjects];
                updated[index][field] = val;
                setFieldValue("eveningShift.subjects", updated);
              };

              const handleRemoveEveningSubject = (index) => {
                const subjects = [...values.eveningShift.subjects];
                const performers = [...values.eveningShift.bestPerformers];
                subjects.splice(index, 1);
                performers.splice(index, 1);
                setFieldValue("eveningShift.subjects", subjects);
                setFieldValue("eveningShift.bestPerformers", performers);
              };

              const handleChangeEveningBestPerformer = (
                index,
                field,
                value
              ) => {
                const updated = [...values.eveningShift.bestPerformers];
                updated[index][field] = value;
                setFieldValue("eveningShift.bestPerformers", updated);
              };
              const handleAddMorningTeacher = () => {
                const updated = [...values.morningShift.teachers, ""];
                setFieldValue("morningShift.teachers", updated);
              };

              const handleChangeMorningTeacher = (val, index) => {
                const updated = [...values.morningShift.teachers];
                updated[index] = val;
                setFieldValue("morningShift.teachers", updated);
              };

              const handleAddMorningSubject = () => {
                setFieldValue("morningShift.subjects", [
                  ...values.morningShift.subjects,
                  { subject: "", topic: "" },
                ]);
                setFieldValue("morningShift.bestPerformers", [
                  ...values.morningShift.bestPerformers,
                  { subject: "", name: "" },
                ]);
              };

              const handleChangeMorningSubject = (val, index, field) => {
                const updated = [...values.morningShift.subjects];
                updated[index][field] = val;
                setFieldValue("morningShift.subjects", updated);
              };

              const handleRemoveMorningSubject = (index) => {
                const subjects = [...values.morningShift.subjects];
                const performers = [...values.morningShift.bestPerformers];
                subjects.splice(index, 1);
                performers.splice(index, 1);
                setFieldValue("morningShift.subjects", subjects);
                setFieldValue("morningShift.bestPerformers", performers);
              };

              const handleChangeMorningBestPerformer = (
                index,
                field,
                value
              ) => {
                const updated = [...values.morningShift.bestPerformers];
                updated[index][field] = value;
                setFieldValue("morningShift.bestPerformers", updated);
              };

              return (
                <Form className="flex-col align-start justify-start g-1 scroll-y pr-05">
                  {/* ----------- Evening Shift Section ----------- */}
                  {editModalShiftChange ? (
                    <EveningShiftModalForm
                      values={values}
                      handleChangeEveningTeacher={handleChangeEveningTeacher}
                      handleAddEveningTeacher={handleAddEveningTeacher}
                      handleChangeEveningSubject={handleChangeEveningSubject}
                      handleAddEveningSubject={handleAddEveningSubject}
                      handleRemoveEveningSubject={handleRemoveEveningSubject}
                      handleChangeEveningBestPerformer={
                        handleChangeEveningBestPerformer
                      }
                    />
                  ) : (
                    <MorningShiftModalForm
                      values={values}
                      handleChangeMorningTeacher={handleChangeMorningTeacher}
                      handleAddMorningTeacher={handleAddMorningTeacher}
                      handleChangeMorningSubject={handleChangeMorningSubject}
                      handleAddMorningSubject={handleAddMorningSubject}
                      handleRemoveMorningSubject={handleRemoveMorningSubject}
                      handleChangeMorningBestPerformer={
                        handleChangeMorningBestPerformer
                      }
                    />
                  )}
                  <button type="submit" className="actionBtn w-full">
                    Update All
                  </button>
                </Form>
              );
            }}
          </Formik>
        </div>
      </SecondModal>

      <div className="w-full h-fit flex-row align-start justify-start relative scroll-x">
        <div
          className="flex-row h-fit align-start justify-start g-1 w-fit"
          ref={scrollableContainer}
        >
          <TuitionCard
            tuitionData=""
            attendanceData={lineChartData}
            headerBtnAction={() => setStudentDetailsModal(true)}
            handelTuition={() => setEditScheduleModal(true)}
          />
        </div>
      </div>
    </section>
  );
};

export default TuitionBody;
